import { Injectable } from '@angular/core';
import { PamlightClient, PamlightClientConfig } from '@pamlight/client';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NgxPamlightService {
  private pamlightClient: PamlightClient;

  constructor() { }

  public init(projectId: string, dev?: boolean): Promise<void> {
    const config: PamlightClientConfig = {
      projectId
    };

    this.pamlightClient = new PamlightClient(config);

    if (dev) {
      this.pamlightClient.enableDevMode();
    }

    return this.pamlightClient.connect();
  }

  public getServerTime(): Observable<Date> {
    return this.pamlightClient.utilities.serverTime();
  }

  public read<T>(id: string, query?: any): Observable<T> {
    return this.pamlightClient.sync<T>(id, query);
  }

  public write<T>(id: string, payload: any, getDoc?: boolean): Promise<T> {
    return this.pamlightClient.write<T>(id, payload, getDoc);
  }
}
